import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap'
import Api from './Api'
class PasswordRecovery extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            EmailPasswordRecovery: '',
            Error: '',
            EmailError: '',
        };
    }
    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ EmailError: '', Error: '' })
        if (this.state.EmailPasswordRecovery === '') {
            this.setState({ EmailError: "Username is empty." })
            return;
        }
        const FETCH_URL = 'api/auth/forgotpassword';
        var data = {
            username: this.state.EmailPasswordRecovery,
        }
        Api.PostApi(FETCH_URL, data, this.props.history).then(d => {
            if (d === undefined) {
                this.setState({ Error: "Username Not found in the system." });
            } else {
                alert('Email with new password sent.');
            }
        })
    }
    render() {
        return (
            <div className="PasswordRecovery">
                <h4>Wachtwoord vergeten</h4>
                <hr />
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="formHorizontalPasswordRecoveryEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                            E-mailadres
                </Col>
                        <Col sm={6}>
                            <FormControl required name='EmailPasswordRecovery' onChange={this.handleChange} type="email" placeholder="e-mail adres - wachtwoord vergeten" />
                            <p style={{ color: 'red' }}>{this.state.EmailError}</p>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col smOffset={2} sm={6}>
                            <Button type="submit">Wachtwoord opvragen</Button>
                            <p style={{ color: 'red' }}>{this.state.Error}</p>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default PasswordRecovery;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/PasswordRecovery.js